
Checkout.Payment.WireTransfer = function(checkout, payment) {
	var wiretransfer = this;

	this.label = 'Wire Transfer';
	this.fee = parseFloat(checkout.config.wireTransferFee);

	this.allowMulti = false;
	this.multiError = 'Wire Transfer payments can\'t be combined with any other payment method';

	this.$addAnotherMenu = $('#payment-method-add-another');
	this.$tpl = $('#payment-method-wiretransfer-tpl');
	this.$wrap = false;

	this.init = function() {
    	if (checkout.config.isEndeca) {
			this.$addAnotherMenu.hide();
		}
		if (Object.keys(payment.methods).length) {
			wiretransfer.addError = wiretransfer.multiError;
			return;
		}

		wiretransfer.$wrap = wiretransfer.$tpl
			.clone(true)
			.removeAttr('id');

		payment.changeFees(wiretransfer, wiretransfer.fee, true);
	};

	this.afterRemoved = function() {
		payment.changeFees(wiretransfer, 0, true);
	};

	this.getData = function() {
		return {};
	};

	this.init();
};

